import { useEffect, useState } from "react";
import { getTemplates } from "../../Services/Template";
import NavBar from "../NavBar";
import TemplatePreview from "./TemplatePreview";
import WelcomeScreen from "./WelcomeScreen";

export default function Templates() {
	const [templates, setTemplates] = useState([]);
	const [filtered, setFiltered] = useState([]);
	const [loading, setLoading] = useState(true);
	const [search, setSearch] = useState("");
	const [selectedTemplate, setSelectedTemplate] = useState(null);

	// ✅ Fetch Templates
	useEffect(() => {
		setLoading(true);

		getTemplates()
			.then((res) => {
				const data = res.data.data || [];
				setTemplates(data);
				setFiltered(data);
			})
			.catch(console.error)
			.finally(() => setLoading(false));
	}, []);

	useEffect(() => {
		const handleEsc = (e) => {
			if (e.key === "Escape") {
				setSelectedTemplate(null);
			}
		};

		window.addEventListener("keydown", handleEsc);
		return () => window.removeEventListener("keydown", handleEsc);
	}, []);

	// ✅ Search Filter
	useEffect(() => {
		if (!search.trim()) {
			setFiltered(templates);
			return;
		}

		const s = search.toLowerCase();

		const result = templates.filter((tpl) => {
			const header =
				tpl.components.find((c) => c.type === "HEADER")?.text || "";
			const body = tpl.components.find((c) => c.type === "BODY")?.text || "";

			return (
				tpl.name.toLowerCase().includes(s) ||
				header.toLowerCase().includes(s) ||
				body.toLowerCase().includes(s)
			);
		});

		setFiltered(result);
	}, [search, templates]);

	return (
		<div className="h-screen flex">
			{/* 🔝 NAVBAR (LEFT) */}
			<NavBar />

			{/* 📄 MAIN CONTENT */}
			<div className="flex flex-1">
				{/* 📄 TEMPLATE LIST */}
				<div className="w-[350px] border-r bg-white flex flex-col">
					{/* 🔍 SEARCH */}
					<div className="p-3 border-b">
						<input
							value={search}
							onChange={(e) => setSearch(e.target.value)}
							placeholder="Search templates..."
							className="w-full px-4 py-2 bg-gray-100 rounded-full text-sm focus:outline-none"
						/>
					</div>

					{/* 📜 LIST / LOADER / EMPTY */}
					<div className="flex-1 overflow-y-auto">
						{loading ? (
							<div className="p-3 space-y-3">
								{[...Array(6)].map((_, i) => (
									<div key={i} className="animate-pulse">
										<div className="h-3 bg-gray-300 rounded w-2/3 mb-2"></div>
										<div className="h-2 bg-gray-200 rounded w-full"></div>
									</div>
								))}
							</div>
						) : filtered.length === 0 ? (
							<div className="text-center text-gray-400 mt-10 text-sm">
								No templates found
							</div>
						) : (
							filtered.map((tpl) => {
								const header = tpl.components.find((c) => c.type === "HEADER");
								const body = tpl.components.find((c) => c.type === "BODY");

								return (
									<div
										key={tpl.id}
										onClick={() => setSelectedTemplate(tpl)}
										className={`p-3 border-b cursor-pointer transition
											${selectedTemplate?.id === tpl.id ? "bg-blue-50" : "hover:bg-gray-50"}`}
									>
										<div className="font-medium text-sm text-gray-800">
											{header?.text || tpl.name}
										</div>

										<div className="text-xs text-gray-500 mt-1 line-clamp-2">
											{body?.text}
										</div>

										<div className="text-[10px] text-gray-400 mt-1">
											{tpl.category}
										</div>
									</div>
								);
							})
						)}
					</div>
				</div>

				{/* 👉 TEMPLATE PREVIEW */}
				<div className="flex-1 bg-gray-50 flex">
					{selectedTemplate ? (
						<TemplatePreview template={selectedTemplate} />
					) : (
											<WelcomeScreen />
						
					)}
				</div>
			</div>
		</div>
	);
}
